const capitalize = str => str.split(' ').map(word => !word[0] ? word : word[0].toUpperCase() + word.slice(1)).join(' ');
export default capitalize;